import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/img/icons/dashboard.svg'
import _imports_1 from '../../assets/img/icons/products.svg'
import _imports_2 from '../../assets/img/icons/create-item.svg'
import _imports_3 from '../../assets/img/icons/item-list.svg'
import _imports_4 from '../../assets/img/icons/sale.svg'
import _imports_5 from '../../assets/img/icons/create-sales.png'
import _imports_6 from '../../assets/img/icons/sales-list.png'
import _imports_7 from '@/assets/img/icons/logout.png'


const _hoisted_1 = {
  id: "sidebar-wrap",
  class: "sidebar-area position-fixed bg_primary transition"
}
const _hoisted_2 = {
  id: "sidebar_menu_wrap",
  class: "sidebar-menu-wrap"
}
const _hoisted_3 = { class: "sidebar-menu list-style" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_6 = { class: "sidebar-secondary-menu list-style bg-white" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_10 = { class: "sidebar-secondary-menu bg-white list-style" }
const _hoisted_11 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_14 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_15 = {
  key: 5,
  class: "nav-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_ctx.hasRole(['Seller', 'Admin','Manager']))
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1),
                  _createElementVNode("span", { class: "nav-text d-block fs-14 fw-light" }, " Dashboard ", -1)
                ])),
                _: 1,
                __: [1]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRole('Admin'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "nav-link"
              }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Image"
                }),
                _createElementVNode("span", { class: "nav-text d-block fs-14" }, " Products ")
              ], -1)),
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/create-product" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "Image"
                      }, null, -1),
                      _createTextVNode(" Create Product ")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: "/product-list" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "Image"
                      }, null, -1),
                      _createTextVNode(" Product List ")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRole(['Admin','Manager']))
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "nav-link"
              }, [
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "Image"
                }),
                _createElementVNode("span", { class: "nav-text d-block fs-14" }, " Sales ")
              ], -1)),
              _createElementVNode("ul", _hoisted_10, [
                (_ctx.hasRole('Admin'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                      _createVNode(_component_router_link, { to: "/create-sales" }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "Image"
                          }, null, -1),
                          _createTextVNode(" Create Sale ")
                        ])),
                        _: 1,
                        __: [5]
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_component_router_link, { to: "/sales-list" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "Image"
                      }, null, -1),
                      _createTextVNode(" Sales List ")
                    ])),
                    _: 1,
                    __: [6]
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRole('Seller'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/create-sales",
                class: "nav-link"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    alt: "Image"
                  }, null, -1),
                  _createElementVNode("span", { class: "nav-text d-block fs-14 fw-light" }, " Create Sale ", -1)
                ])),
                _: 1,
                __: [8]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRole('Seller'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/sales-list",
                class: "nav-link"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("img", {
                    src: _imports_6,
                    alt: "Image"
                  }, null, -1),
                  _createElementVNode("span", { class: "nav-text d-block fs-14 fw-light" }, " Sales List ", -1)
                ])),
                _: 1,
                __: [9]
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRole(['Seller', 'Admin']))
          ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
              _createElementVNode("a", {
                class: "nav-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: _imports_7,
                  alt: "Logout"
                }, null, -1),
                _createElementVNode("span", { class: "nav-text d-block fs-14 fw-light" }, " Logout ", -1)
              ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}